import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { loadUser, clearUser } from '../../common/users/actions'
import { Title } from '../components'
import { UserForm } from '../forms'

class UserPage extends React.Component {
  componentDidMount() {
    const { match, loadUser, user } = this.props
    const { params } = match
    if (params.user && (!user._id || params.user !== user._id)) loadUser(params.user)
  }
  componentWillUnmount() {
    this.props.clearUser()
  }
  render() {
    const { match, user } = this.props
    const { params } = match
    let userForm = null
    if (params.user || (user && user._id)) {
      if (user._id) userForm = <UserForm user={user} />
    } else {
      userForm = <UserForm />
    }
    const title = user._id ? user.name : 'Nový uživatel'
    return (
      <div>
        <Title message={title} />
        <aside className="breadcrumbs">
          <Link to="/users">Uživatelé</Link>
          <img src="/images/arrow.png" alt="arrow-right" />
          <span>{title}</span>
        </aside>
        <main className="form-page thin">
          {userForm}
        </main>
      </div>
    )
  }
}

UserPage.propTypes = {
  match: React.PropTypes.object.isRequired,
  user: React.PropTypes.object.isRequired,
  loadUser: React.PropTypes.func.isRequired,
  clearUser: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  user: state.users.current,
}), { loadUser, clearUser })(UserPage)



// WEBPACK FOOTER //
// ./src/browser/pages/User.js